var hasProp = window.hasProp;
var extend = window.extend;
var extend = function (child, parent) {
    for (var key in parent) {
      if (hasProp.call(parent, key)) child[key] = parent[key];
    }
    function ctor() {
      this.constructor = child;
    }
    ctor.prototype = parent.prototype;
    child.prototype = new ctor();
    child.__super__ = parent.prototype;
    return child;
  },
  hasProp = {}.hasOwnProperty;
c.ResearchInterestCard = function (superClass) {
  extend(ResearchInterestCard, superClass);
  function ResearchInterestCard() {
    return ResearchInterestCard.__super__.constructor.apply(this, arguments);
  }
  ResearchInterestCard.prototype.initialize = function (options) {
    ResearchInterestCard.__super__.initialize.call(this, {
      html: true,
      placement: 'bottom',
      container: this._cardContainer(),
      show_delay: 400,
      hide_delay: 250,
      content: function (_this) {
        return function () {
          return _this._cardContent();
        };
      }(this),
      template: function () {
        return $($.fn.popover.Constructor.DEFAULTS.template).addClass('popover-hovercard ri-card');
      }(),
      sanitize: false
    });
    if (this.options.ri != null) {
      this.ri = new Aedu.ResearchInterest(this.options.ri);
    } else {
      this.ri = this._findResearchInterestFromContent();
    }
    if (this.ri != null) {
      this._initClickable();
      return this.on_shown = this._showStats;
    }
  };
  ResearchInterestCard.prototype._findResearchInterestFromContent = function () {
    var content, content_el, ri_id;
    ri_id = this.$el.data('has-card-for-ri');
    content_el = $("*[data-card-contents-for-ri=" + ri_id + "]");
    if (content_el && (content = content_el.html())) {
      return this.ri = new Aedu.ResearchInterest(JSON.parse(content));
    }
  };
  ResearchInterestCard.prototype._initClickable = function () {
    return this.$el.data('bs.popover').tip().on('click', '.js-ri-card-main', function (_this) {
      return function (e) {
        if (!(e.metaKey || e.ctrlKey)) {
          return window.location = _this.ri.get('url');
        }
      };
    }(this));
  };
  ResearchInterestCard.prototype._showStats = function ($popover) {
    var setStat;
    setStat = function (_this) {
      return function (stat, value) {
        var selector;
        selector = "*[data-stats-for-ri=" + _this.ri.id + "] .js-ri-card-stat-num[data-stat=" + stat + "]";
        return $popover.find(selector).text($h.commaizeInt(value));
      };
    }(this);
    this.ri.loadFollowersCount().done(function (c) {
      return setStat('followers_count', c);
    });
    return this.ri.loadWorksCount().done(function (c) {
      if (c !== 'no_count') {
        return setStat('works_count', c);
      }
    });
  };
  ResearchInterestCard.prototype._cardContent = function () {
    return JST['core_post_webpack/sitewide_business_elements/research_interest_card/templates/card']({
      ri: this.ri.toJSON()
    });
  };
  ResearchInterestCard.prototype._cardContainer = function () {
    if (!(this.$el.parent().is("div, li") && this.$el.parents('.bootstrap').length)) {
      return '#bootstrap-modal-container';
    }
  };
  return ResearchInterestCard;
}(HoverPopover);
if ($a.is_logged_in()) {
  $a.each_current_and_future('*[data-has-card-for-ri]', function (el) {
    return new c.ResearchInterestCard({
      el: $(el)
    });
  });
}
window.extend = extend;
window.hasProp = hasProp;